import React, { useState } from 'react';

import {
  Grid,
  Container,
  InputAdornment,
  Button,
  TextField,
} from '@material-ui/core';
import { useNotify, Notification } from 'react-admin';
import apolloClient from 'apollo/apolloClient';
import MailOutlineTwoToneIcon from '@material-ui/icons/MailOutlineTwoTone';
import logo from '../logo.png';
import illustration1 from 'assets/images/illustrations/pack1/security.svg';
import { forgotPasswordRequest } from 'apollo';

export default function RecoverPage({ isLoading }) {
  const notify = useNotify();
  const [email, setEmail] = useState('');

  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      notify('Email Address must not be empty', { type: 'warning' });
      return;
    }

    setLoading(true);
    try {
      const { data } = await apolloClient.mutate({
        mutation: forgotPasswordRequest,
        variables: {
          email,
        },
      });

      setLoading(false);
      notify('A reset password link as been sent to your email', {
        type: 'success',
      });
    } catch (error) {
      setLoading(false);
      console.log(`error`, error);

      notify(`${error}`, { type: 'error' });
    }
  };
  return (
    <>
      <div className='app-wrapper bg-white min-vh-100'>
        <div className='app-main min-vh-100'>
          <div className='app-content p-0'>
            <div className='app-content--inner d-flex align-items-center'>
              <div className='flex-grow-1 w-100 d-flex align-items-center'>
                <div className='bg-composed-wrapper--content py-5'>
                  <Notification />
                  <Container>
                    <Grid container spacing={6}>
                      <Grid item lg={6} className='d-flex align-items-center'>
                        <div className='divider-v d-none d-lg-block divider-v-md' />
                        <div className='w-100 pr-0 pr-lg-5'>
                          <div className='text-center my-5'>
                            <h1 className='display-4 mb-1 font-weight-bold'>
                              Recover Password
                            </h1>
                            <p className='font-size-lg mb-0 text-black-50'>
                              Forgot your password? No worries, we're here to
                              help!
                            </p>
                          </div>
                          <form onSubmit={handleSubmit}>
                            <div>
                              <label className='font-weight-bold mb-2'>
                                Email address
                              </label>
                              <TextField
                                fullWidth
                                variant='outlined'
                                id='textfield-email'
                                type='email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                name='email'
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position='start'>
                                      <MailOutlineTwoToneIcon />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>
                            <div className='text-center mb-5'>
                              <Button
                                fullWidth
                                type='submit'
                                disabled={loading}
                                className='text-uppercase font-weight-bold font-size-sm mt-4 btn-primary'
                              >
                                Update Password
                              </Button>
                            </div>
                            <div className='text-center mb-5'>
                              <img
                                alt='...'
                                className='w-50 mx-auto d-block img-fluid'
                                src={logo}
                              />
                            </div>
                          </form>
                        </div>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        className='d-none d-lg-flex align-items-center'
                      >
                        <img
                          alt='...'
                          className='w-100 mx-auto d-block img-fluid'
                          src={illustration1}
                        />
                      </Grid>
                    </Grid>
                  </Container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
